export default __webpack_public_path__ + "static/media/cfjp03.47be98cc.png";